//file for common function across modules

export const GetSourceOwner = (appDetail) => {
  const method = appDetail?.sourcingdetails?.method;

  switch (method) {
    case "By Team":
    case "By Automation":
      return {
        sourceName: appDetail?.sourcingdetails?.teamdetails?.name || "Unknown",
        sourceID: appDetail?.sourcingdetails?.teamdetails?.qhuid || "--",
        sourceDate:
          appDetail?.sourcingdetails?.teamdetails?.updatedon || "Unknown",
      };

    case "By Vendor":
      return {
        sourceName: appDetail?.sourcingdetails?.vendordetails?.name || "Unknown",
        sourceID: appDetail?.sourcingdetails?.vendordetails?.qhvid || "--",
        sourceDate:
          appDetail?.sourcingdetails?.vendordetails?.updatedon || "Unknown",
      };

    case "Through Career Page":
      return {
        sourceName: appDetail?.sourcingdetails?.careerpages?.name || "Unknown",
        sourceID: "--",
        sourceDate:
          appDetail?.sourcingdetails?.careerpages?.updatedon || "Unknown",
      };

    case "By Candidate":
      return {
        sourceName:
          appDetail?.sourcingdetails?.portalapplication?.name || "Unknown",
        sourceID: "--",
        sourceDate:
          appDetail?.sourcingdetails?.portalapplication?.updatedon ||
          "Unknown",
      };

    default:
      return {
        sourceName: "Unknown",
        sourceID: "--",
        sourceDate: "Unknown",
      };
  }
};

export const GetOwnership = (thisResume) => {
  const method = thisResume?.firstuploadedby?.method;

  switch (method) {
    case "By Team":
      return {
        sourceName:
          thisResume?.firstuploadedby?.teamdetails?.name || "Unknown",

        sourceID:
          thisResume?.firstuploadedby?.teamdetails?.qhuid || "--",

        sourceDate:
          thisResume?.firstuploadedby?.teamdetails?.updatedon || "--",
      };

    case "By Vendor":
      return {
        sourceName:
          thisResume?.firstuploadedby?.vendordetails?.name || "Unknown",

        sourceID:
          thisResume?.firstuploadedby?.vendordetails?.qhvid || "--",

        sourceDate:
          thisResume?.firstuploadedby?.vendordetails?.updatedon || "--",
      };

    case "Through Career Page":
      return {
        sourceName:
          thisResume?.firstuploadedby?.careerpages?.name || "Unknown",

        sourceID: "--",

        sourceDate:
          thisResume?.firstuploadedby?.careerpages?.updatedon || "--",
      };

    case "By Candidate":
      return {
        sourceName:
          thisResume?.firstuploadedby?.portalapplication?.name || "Unknown",

        sourceID: "--",

        sourceDate:
          thisResume?.firstuploadedby?.portalapplication?.updatedon || "--",
      };

    default:
      return {
        sourceName: "Unknown",
        sourceID: "--",
        sourceDate: "--",
      };
  }
};